"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OptionsReader = /** @class */ (function () {
    function OptionsReader(incoming, context) {
        var _this = this;
        this.enableTouchEvents = true;
        this.enableMouseEvents = false;
        this.enableKeyboardEvents = false;
        this.ignoreContextMenu = false;
        this.enableHoverOutsideTarget = false;
        this.touchSlop = 0;
        this.scrollAngleRanges = undefined;
        this.context = context;
        this.delayTouchStart = incoming.delayTouchStart || incoming.delay || 0;
        this.delayMouseStart = incoming.delayMouseStart || incoming.delay || 0;
        Object.keys(incoming).forEach(function (key) {
            if (incoming[key] != null) {
                ;
                _this[key] = incoming[key];
            }
        });
    }
    Object.defineProperty(OptionsReader.prototype, "window", {
        get: function () {
            if (this.context && this.context.window) {
                return this.context.window;
            }
            else if (typeof window !== 'undefined') {
                return window;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OptionsReader.prototype, "document", {
        get: function () {
            if (this.window) {
                return this.window.document;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    return OptionsReader;
}());
exports.OptionsReader = OptionsReader;
